import { render, staticRenderFns } from "./ClientLinkBranchDesktop.vue?vue&type=template&id=0e53ce7c&scoped=true&"
import script from "./ClientLinkBranchDesktop.vue?vue&type=script&lang=js&"
export * from "./ClientLinkBranchDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e53ce7c",
  null
  
)

export default component.exports